import qs from 'qs';
import { network } from 'services/network';

export const getResourceListForChart = ({ latestVersion }: { latestVersion: number }) => {
    const querystring = qs.stringify({ metaDataId: latestVersion }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getResourceListForChart${querystring}`;

    return network.get(url).then((response) => {
        return response.data;
    });
};
